export default "__VITE_ASSET__BEkLph2B__"